var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThnkWorldLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 90,
    viewBox: "0 0 195 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "THNK World Logo 2",
    clipPath: "url(#clip0_1_450)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M65.9765 89.6039H57.0139L46.0118 49.6974H54.2946L61.556 80.7108L69.553 49.6974H78.1182L85.9445 80.5986L93.2617 49.6974H101.485L90.4833 89.6039H81.5207L73.8061 60.9276L65.9798 89.6039H65.9765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M115.611 90C112.849 90 110.392 89.4025 108.238 88.2042C106.083 87.006 104.389 85.3158 103.16 83.1305C101.932 80.9452 101.318 78.3704 101.318 75.406C101.318 72.4417 101.942 69.8008 103.19 67.5957C104.438 65.3906 106.169 63.6906 108.379 62.4923C110.593 61.294 113.059 60.6965 115.782 60.6965C118.504 60.6965 120.971 61.294 123.184 62.4923C125.398 63.6906 127.145 65.3807 128.432 67.566C129.716 69.7513 130.36 72.3262 130.36 75.2905C130.36 78.2549 129.707 80.8957 128.403 83.1008C127.099 85.3059 125.329 87.006 123.099 88.2042C120.866 89.4025 118.373 90 115.611 90ZM115.611 83.4441C116.783 83.4441 117.89 83.1503 118.928 82.5594C119.966 81.9718 120.829 81.0773 121.509 79.879C122.189 78.6807 122.531 77.1523 122.531 75.2905C122.531 73.4287 122.209 72.0126 121.565 70.8143C120.921 69.616 120.081 68.7247 119.039 68.1338C117.998 67.5462 116.875 67.2491 115.663 67.2491C114.451 67.2491 113.404 67.5429 112.402 68.1338C111.4 68.7247 110.596 69.616 109.992 70.8143C109.387 72.0126 109.085 73.5409 109.085 75.4027C109.085 77.2645 109.377 78.6807 109.965 79.879C110.55 81.0773 111.335 81.9685 112.32 82.5594C113.302 83.1503 114.399 83.4441 115.611 83.4441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M134.656 61.096H141.293L141.747 64.7436C142.541 63.7566 143.438 62.9379 144.44 62.2909C145.441 61.6439 146.538 61.2082 147.73 60.9804C148.923 60.7526 150.197 60.789 151.56 61.0927V67.8763C150.578 67.5726 149.517 67.4967 148.384 67.6486C147.251 67.8004 146.2 68.1998 145.238 68.8468C144.272 69.4938 143.481 70.4247 142.857 71.6395C142.233 72.8576 141.921 74.3563 141.921 76.1422V89.5973H134.659V61.0927L134.656 61.096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M154.808 48.5552H162.066V89.6039H154.808V48.5552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M188.648 65.3741L187.742 65.5458V48.5585H195.003V89.6072H188.425L187.972 86.0717C187.101 87.1743 185.909 88.1052 184.399 88.8644C182.885 89.6237 181.167 90.0033 179.236 90.0033C176.74 90.0033 174.546 89.3959 172.658 88.1778C170.766 86.963 169.291 85.2531 168.234 83.048C167.176 80.8429 166.644 78.2779 166.644 75.3532C166.644 72.4285 167.173 69.8041 168.234 67.599C169.291 65.3939 170.766 63.6939 172.658 62.4956C174.549 61.2973 176.743 60.6998 179.236 60.6998C181.39 60.6998 183.282 61.1554 184.908 62.0665C186.533 62.9775 187.781 64.0801 188.652 65.3741H188.648ZM174.411 75.3499C174.411 77.7069 175.025 79.6248 176.254 81.1069C177.482 82.5891 179.078 83.3319 181.045 83.3319C182.254 83.3319 183.361 83.0183 184.362 82.3911C185.364 81.7639 186.179 80.8627 186.803 79.6842C187.427 78.5057 187.739 77.0632 187.739 75.3532C187.739 73.6433 187.427 72.1974 186.803 71.0189C186.179 69.8404 185.364 68.9393 184.362 68.3121C183.361 67.6849 182.254 67.3713 181.045 67.3713C179.078 67.3713 177.482 68.1107 176.254 69.5929C175.025 71.075 174.411 72.9962 174.411 75.3499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M57.7134 39.3288V7.74758H45.8377V0H78.5583V7.74758H66.6826V39.309H57.7102V39.3288H57.7134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M82.3417 39.3288V0H91.3142V15.175L107.716 15.1948V0.0198063L116.708 0V39.3288L107.716 39.3486V22.9456L91.3142 22.9258V39.309H82.3417V39.3288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M156.154 39.3288H144.719L136.249 22.8235C133.566 17.5913 131.362 13.0821 130.501 10.7879H130.442C130.541 13.9668 130.541 19.2022 130.541 23.2658V39.3288H122.271V0H133.864L143.816 19.6842C145.78 23.5893 147.1 26.831 147.98 28.7621H148.039C147.941 25.5205 147.878 21.6153 147.878 17.3702V0H156.148V39.3288H156.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M161.741 39.3288V0H170.713V17.4296H170.812C174.536 11.5933 178.743 6.05744 183.068 0H193.841C189.036 6.15977 184.208 12.1578 179.403 18.2548L194.783 39.3288H183.729C179.784 33.4925 174.257 25.5799 170.812 19.8063H170.713V39.3288H161.741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M35.7848 17.9742H32.4414V21.3347H35.7848V17.9742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M6.68665 17.9742H3.34332V21.3347H6.68665V17.9742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M29.8568 6.94542L32.2181 4.57196L34.5795 6.94542L32.2181 9.31888L29.8568 6.94542ZM27.4724 9.34199L4.54535 32.3867L6.9067 34.7601L29.8568 11.7154L27.4724 9.34199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M21.2456 3.36047H17.9022V6.72095H21.2456V3.36047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M21.2456 32.6078H17.9022V35.9683H21.2456V32.6078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M9.27647 6.95725L6.91238 9.33347L9.27647 11.7097L11.6406 9.33347L9.27647 6.95725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M39.1281 17.9742H35.7848V21.3347H39.1281V17.9742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M3.34333 17.9742H0V21.3347H3.34333V17.9742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M21.2258 0H17.8825V3.36048H21.2258V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M21.2258 35.9683H17.8825V39.3288H21.2258V35.9683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M6.91997 4.57679L4.55588 6.953L6.91997 9.32922L9.28406 6.953L6.91997 4.57679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M32.207 30.0066L29.8429 32.3828L32.207 34.759L34.5711 32.3828L32.207 30.0066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M29.8568 27.6166L23.6102 21.3545H32.4414V17.9742H21.2456V6.74405H17.8825V15.5975L11.6557 9.33868L9.29103 11.7154L15.5179 17.9742H6.70964V21.3545H17.8825V32.6078H21.2456V23.7313L27.4757 30.0099L29.8568 27.6166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M29.8472 27.6261L27.4831 30.0023L29.8472 32.3785L32.2113 30.0023L29.8472 27.6261Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThnkWorldLogo);
export default __webpack_public_path__ + "static/media/THNK-World-Logo.d8603e719f2b748bf47d412d5ff2bacb.svg";
export { ForwardRef as ReactComponent };